import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import { defineMessages, useIntl } from "react-intl";

import SavedAddressType, {
  ReservedSavedAddressType,
} from "@mapmycustomers/shared/enum/SavedAddressType";

import styles from "./CommonRow.module.scss";
import savedAddressIcons from "./savedAddressIcons";

const messages = defineMessages({
  notSet: {
    id: "savedLocations.setRow.notSet",
    defaultMessage: "Not set yet",
    description: "Subtitle of the picker row that sets an empty Home or Work saved location",
  },
  [SavedAddressType.HOME]: {
    id: "savedLocations.setRow.home",
    defaultMessage: "Set your Home",
    description: "Title of the picker row that sets the rep's empty Home saved location",
  },
  [SavedAddressType.WORK]: {
    id: "savedLocations.setRow.work",
    defaultMessage: "Set your Work",
    description: "Title of the picker row that sets the rep's empty Work saved location",
  },
  set: {
    id: "savedLocations.setRow.set",
    defaultMessage: "Set",
    description: "Action label of the picker row that sets an empty Home or Work saved location",
  },
});

export interface SetSavedAddressRowProps {
  type: ReservedSavedAddressType;
}

const SetSavedAddressRow = ({ type }: SetSavedAddressRowProps) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <span className={cn(styles.glyph, styles.unset)}>
        <FontAwesomeIcon icon={savedAddressIcons[type]} />
      </span>
      <div className={styles.text}>
        <div className={cn(styles.title, styles.unset)}>{intl.formatMessage(messages[type])}</div>
        <div className={cn(styles.subtitle, styles.unset)}>
          {intl.formatMessage(messages.notSet)}
        </div>
      </div>
      <span className={styles.action}>{intl.formatMessage(messages.set)}</span>
    </div>
  );
};

export default SetSavedAddressRow;
